import styled from '@emotion/styled';
import { Box, Typography, List, ListItem } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';
import { fontFamily } from 'styled-system';

export const FeatureContent = styled(Box)({
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '0 20px',

  '@media (max-width: 900px)': {
    width: '100%',
  },
});

export const FeatureCard = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '0 24px',
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
  width: '100%',
});

export const IconContainer = styled(Box)(({ iconColor }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '16px',
  flexShrink: 0,
  background: 'var(--grey-transparent-8, rgba(145, 155, 171, 0.08))',
  marginTop: '10px',
  alignSelf: 'flex-start',

  '& img, & svg': {
    color: iconColor,
    width: '24px',
    height: '24px',
  },
}));

export const FeatureItemContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const FeatureDescription = styled(Typography)({
  fontSize: '16px',
  color: '#4B5563',
  lineHeight: 1.5,

  '@media (max-width: 768px)': {
    fontSize: '14px',
  },
});

export const FeatureListTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: '700',
  color: '#111927',
  '@media (max-width: 768px)': {
    fontSize: '18px',
  },
});

export const FeatureTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: '600',
  color: '#111927',
  lineHeight: 1.2,

  '@media (max-width: 768px)': {
    fontSize: '16px',
  },
});

export const Styled = {
  Title: {
    color: '#111927',
    fontSize: [
      `${saasModernTheme.space[8]}px`,
      `${saasModernTheme.space[11]}px`,
      `${saasModernTheme.space[11]}px`,
    ],
    fontFamily: saasModernTheme.fontFamily,
    fontWeight: 900,
    width: '100%',
    strong: {
      background: saasModernTheme.customColor.backgroundTextGradient,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      color: 'transparent',
    },
  },
  ListContainer: {
    width: '100%',
  },
  ListItem: {
    padding: '12px 0',
    alignItems: 'flex-start',
  },
  CheckListContainer: {
    display: 'flex',
    alignItems: 'flex-start',

  },
  CheckListText: {
    marginLeft: 2,
  },
  FeatureList: {
    padding: 0,
  },
  ListFeatureItem: {
    display: 'flex',
    alignItems: 'center',

  },
  FeatureDescriptionSmall: {
    fontSize: '16px',
    fontFamily: saasModernTheme.fontFamily,
    color: '#4B5563',
    marginTop: 1,
  },
  FeatureDescriptionCard: {
    fontSize: '14px',
    fontFamily: saasModernTheme.fontFamily,
    color: '#4B5563',
    lineHeight: 1.5,
    marginTop: '-16px',
  },
  UL: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    color: '#111927',
    fontSize: '16px',
    fontWeight: 600,
  },
};
